export default __webpack_public_path__ + "static/media/menu.f11b0bb1.svg";